


























import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { ELabelSize, BaseLabel } from '../base-label';

@Component({
  name: 'BaseRadioButton',
  components: {
    BaseLabel,
  },
  data: () => ({
    ELabelSize,
  }),
})
export default class BaseRadioButton extends Vue {
  @Model('change') selectedValue!: any;
  @Prop() value!: any;
  @Prop({ default: '' }) label: string;
  @Prop() id: string;
  @Prop({ default: false }) disabled: boolean;

  get checked() {
    return this.value === this.selectedValue;
  }

  handleClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('change', this.value);
  }

  get radioButtonId(): string {
    return this.id || `input-radio-button-${this['_uid']}`;
  }

  get radioButtonLabelId(): string {
    return `input-radio-button-label-${this['_uid']}`;
  }
}
